/**
 * @license
 *
 * Copyright IBM Corp. 2020, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { css } from 'lit';
import settings from '@carbon/ibmdotcom-utilities/es/utilities/settings/settings.js';
import { carbonElement as customElement } from '@carbon/web-components/es/globals/decorators/carbon-element.js';
import C4DContentGroup from '../content-group/content-group';
import styles from './content-group-pictograms.scss';

const { stablePrefix: c4dPrefix } = settings;

/**
 * Content group with pictograms
 *
 * @element c4d-content-group-pictogram
 */

@customElement(`${c4dPrefix}-content-group-pictograms`)
class C4DContentGroupPictograms extends C4DContentGroup {
  static get stableSelector() {
    return `${c4dPrefix}--content-group-pictograms`;
  }

  // `styles` here is a `CSSResult` generated by custom WebPack loader
  static get styles() {
    return css`
      ${super.styles}${styles}
    `;
  }
}

console.warn(
  'The content-group-pictograms component has been deprecated in favor of the content-section/block and content-item (pictogram variant) components. ' +
    'See content-section/block and content-item documentation for more information.'
);

/* @__GENERATE_REACT_CUSTOM_ELEMENT_TYPE__ */
export default C4DContentGroupPictograms;
